<script>
export default {
  components: {},
  props: {
    lists: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};

  },
  methods: {

    onNewClick(type,url){
      if(type===2){
        parent.location.href = url;
      }else if(type===1){
        this.$router.push(url);
        // parent.location.href = window.location.protocol + '//' + window.location.host + url;
      }
    },
  },
  mounted() {

  },
};
</script>

<template>
  <div class="new-layout">
    <div style="text-align: left" class="title">
      <img class="new-title-icon" src="@/assets/new_title.png">
    </div>
    <div class="new-list-layout">
      <div class="new-list">
        <div v-for="(item,i) in lists" :key="i" class="new-item-layout"  @click="onNewClick(item.type,item.h5url)" >
          <div class="image-layout">
            <img class="new-icon" :src="item.imgUrl">
            <img v-if="item.type ===2" class="play-icon" src="@/assets/video_paly.png">
          </div>
          <div class="new-title-layout">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="desc">
              {{ item. desc}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.new-layout {
  .title {
    .new-title-icon {
      height: 3.8rem;
    }
  }

  .new-list-layout {
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding: 0.5rem;
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: flex-start;


    .new-list {

      .new-item-layout {
        margin-top: 0.8rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .new-title-layout {
          margin-left: 0.5rem;
          height: 7.5rem;
          .title {
            text-align: left;
            color: rgba(35, 35, 35, 1);
            font-weight: bold;
            font-size: 1rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          .desc {
            text-align: left;
            margin-top: 0.5rem;
            color: rgba(80, 80, 80, 1);
            font-size: 0.9rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            //width: 200px; /* 或者你希望的宽度 */

          }
        }

        .image-layout {
          position: relative;

          .play-icon{
            position: absolute;
            top: 1.7rem;
            left: 3.9rem;
            width: 3.5rem;
          }

          .new-icon {
            width: 11rem;
            height: 7.5rem;
            object-fit: cover;
          }
        }
      }

    }
  }
}
</style>
